export const environment = {
  production: false,
  APP_BASE_URL: 'https://texicondev.ingredion.com/texiconapi/',
  AUTH_CONFIG: {
    clientId: '3c8264c1-8482-4620-82b5-9ed997b8648c',
    authority:
      'https://login.microsoftonline.com/8d88c9c2-2058-486d-9cd4-2fc9010326bc',
    redirectUri: 'https://texicondev.ingredion.com',
    postLogoutRedirectUri: 'https://texicondev.ingredion.com',
    default_scope: ['user.read'],
    scope: ['api://f0f6f677-2a8e-411b-886f-d5a17a0ace5e/access_as_user'],
  },
  API_CONFIG: {
    uri: 'https://graph.microsoft.com/v1.0/me',
    scope: ['api://f0f6f677-2a8e-411b-886f-d5a17a0ace5e/access_as_user'],
  },
  AG_GRID_K: '6247047890123456',
  AG_GRID_K_IV: '6543210987624704',
};
